try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');
  window.Swal = require('sweetalert2');

  require('bootstrap');
} catch (e) {
}

require('./mp/app');
require('./mp/app.init');

// Gráficos
require('../../node_modules/perfect-scrollbar/dist/js/perfect-scrollbar.jquery');
require('../../node_modules/jquery-sparkline/jquery.sparkline');

require('./mp/waves');
require('./mp/sidebarmenu');

require('./mp/custom');

// index.html
require('./mp/dashboard1');

// require('../../node_modules/datatables.net/js/jquery.dataTables.js');
// require('../../node_modules/datatables.net-bs4/js/dataTables.bootstrap4.js');
